// extracted by mini-css-extract-plugin
export var filterIncDec = "_cx-0";
export var leftBorder = "_cx-1";
export var rightBorder = "_cx-2";
export var stringInput = "_cx-3";